import React from "react";
import ConsumptionByFacility from "./ConsumptionFacility";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import Scope2Layout from "../../../../Layout/Scope2Layout";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";

const HeatFacility = () => {
  return (
    <MainDashboardLayout sidebar={<Scope2Layout />}>
      <Unauthorized requiredModule="Environment | Scope 2 | Heating / Cooling">
        <ConsumptionByFacility />
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default HeatFacility;
